import React from "react";
import classes from "./Order.module.scss";

const Order = (props) => {
  const ingredients = Object.entries(props.ingredients);
  const ingredientList = [];
  for (let x = 0; x < ingredients.length; x++) {
    ingredientList.push(
      <span
        style={{
          textTransform: "capitalize",
          display: "inline-block",
          margin: "0 8px 8px 8px",
          padding: "5px",
          border: "1px solid #ccc",
        }}
        key={ingredients[x]}
      >
        {ingredients[x][0] + ": " + ingredients[x][1]}
      </span>
    );
  }

  return (
    <div className={classes.Order}>
      <p>
        Ingredients:
        {ingredientList}
      </p>
      <p>
        Price: <strong>${props.price.toFixed(2)}</strong>
      </p>
    </div>
  );
};

export default Order;
